import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Login from "./Pages/Login/login";
import { ConfigProvider } from "antd";
import ptPT from 'antd/lib/locale/pt_PT';
import './laravel-echo';
import { useLocation } from "react-router";
import Layout from "./Layout/Layout";
import { env } from "./services/utils";

const safeParse = (value: string | null) => {
  try {
    return value ? JSON.parse (value) : null;
  } catch (error) {
    console.error("JSON inválido:", error);
    localStorage.removeItem("user");
    return null;
  }
};

export default function App({ children, header }: any) {
  const queryClient = new QueryClient();
  const userStorage = localStorage.getItem("user") || null;
  const [user] = useState(safeParse(userStorage));
  const { pathname } = useLocation();

  return (
    <ConfigProvider
      locale={ptPT}
      theme={{
        token: {
          colorPrimary: '#107b99',
          colorBgLayout: env.DEV ? '#bfe8e4' : '#ebf3f5',
        },
        components: {
          Button: {
            colorPrimary: '#107b99',
            colorLink: '#107b99',
          },
          Menu: {
            itemSelectedBg: '#dfe6e8',
            itemSelectedColor: '#252626',
            itemHoverColor: '#107b99',
            itemColor: '#252626',
          },
          Select: {
            controlItemBgActive: '#d1fdff'
          }
        }
      }} 
    >

      <QueryClientProvider client={queryClient}>
      {(!user || ['/forgot-password', '/reset-password' ].includes(pathname) )
      ? <Login />
      : <Layout />
      }
      </QueryClientProvider>

    </ConfigProvider>
  );
}
